export const CSS = {
  icon: "icon",
  flipRtl: "flip-rtl",
};
